import { CustomData, TransactionStatus } from './models/data-storage.model';
import { doesRequestInfoTypeRequireDocsUpload } from './redux/slices/appData/app-data.selectors';

export const routes = {
  application: {
    legitimationLanding: '/',
    upload: '/upload',
    legitimationResult: '/acknowledgement',
    legitimationCallback: '/legitimation-result'
  },
  linkExpired: '/expired',
  sessionTimeout: '/timeout',
  error: '/error'
} as const;

export function routeByStatus(
  status: TransactionStatus,
  { requestInfoType }: { requestInfoType: CustomData['requestInfoType'] | undefined }
) {
  switch (status) {
    case TransactionStatus.LEGITIMATION_INITIALIZED:
      return routes.application.legitimationLanding;
    case TransactionStatus.LEGITIMATION_DIGITAL_CONDUCTED:
      if (doesRequestInfoTypeRequireDocsUpload(requestInfoType)) {
        return routes.application.upload;
      }
      return routes.application.legitimationResult;
    case TransactionStatus.DOCUMENTS_UPLOADED:
    case TransactionStatus.LEGITIMATION_CONDUCTED:
    case TransactionStatus.ACCEPTED:
      return routes.application.legitimationResult;
    case TransactionStatus.TRANSACTION_EXPIRED:
    case TransactionStatus.CANCELED:
      return routes.linkExpired;
    default:
      return routes.error;
  }
}
